<template>
  <div>
    <header></header>
    <section class="YnaviContent">
      <div class="mainMenu"></div>
      <div class="subMenu"></div>
      <div class="mainCon">
        <sk-nonsupport-i18n></sk-nonsupport-i18n>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'sk-layouts',
  mounted() {
    // const s = document.createElement('script')
    // s.type = 'text/javascript'
    // s.src = '//static2.jdcloud.com/Ynavi.js'
    // document.body.appendChild(s)
  },
}
</script>
